"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get GetUserCalendarsParams () {
        return GetUserCalendarsParams;
    },
    get InitiateCalendarIntegrationOAuthFlowParams () {
        return InitiateCalendarIntegrationOAuthFlowParams;
    },
    get OAuthCallbackParams () {
        return OAuthCallbackParams;
    },
    get SaveSelectedCalendarRequest () {
        return SaveSelectedCalendarRequest;
    },
    get UpdateCompanyCalendarIntegrationSettingsRequest () {
        return UpdateCompanyCalendarIntegrationSettingsRequest;
    }
});
const _zod = require("zod");
const UpdateCompanyCalendarIntegrationSettingsRequest = _zod.z.object({
    enabled: _zod.z.boolean()
});
const InitiateCalendarIntegrationOAuthFlowParams = _zod.z.object({
    provider: _zod.z.enum([
        "google",
        "outlook"
    ])
});
const SaveSelectedCalendarRequest = _zod.z.object({
    calendarId: _zod.z.string()
});
const GetUserCalendarsParams = _zod.z.object({
    provider: _zod.z.enum([
        "google",
        "outlook"
    ])
});
const OAuthCallbackParams = _zod.z.object({
    provider: _zod.z.enum([
        "google",
        "outlook"
    ])
});
